const PREORDER_TAG = 'preorder';

export const isPreOrderLineItem = (lineItem) => {
  const tags = lineItem?.variant?.product?.tags || [];
  if (!tags?.length) return false;
  return tags.includes(PREORDER_TAG);
};
